import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { UserEffectivePermissionsService } from 'src/app/features/service/user-effective-permissions.service';

@Component({
  selector: 'app-landing-redirect',
  template: '',
})
export class LandingRedirectComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly permissionsService = inject(UserEffectivePermissionsService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    if (
      !this.permissionsService.isEnforcementEnabled() ||
      this.permissionsService.isLoggedInSuperAdmin()
    ) {
      void this.router.navigate(['dashboard']);
      return;
    }

    this.permissionsService
      .waitUntilResolved()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        void this.router.navigate(
          this.permissionsService.getDefaultLandingRoute()
        );
      });
  }
}
